import React, { useState, useEffect, useMemo } from 'react';
import { Button, ButtonGroup, Col, Row, Accordion, Card } from 'react-bootstrap';
import { Header, Segment, Image, Icon, Dimmer, Loader } from 'semantic-ui-react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { Link, useHistory } from "react-router-dom";
import Amplify, { API, Auth } from 'aws-amplify';
import { store } from 'xijs';
import { Typography } from 'antd';

function simulateNetworkRequest() {
  return new Promise((resolve) => setTimeout(resolve, 2000));
}

export default function PCPD_Result() {

  const [params, setParams] = useState([]);

  const [id_import, setId_import] = useState();

  const [items, setItems] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const [isLoaded1, setIsLoaded1] = useState(false);

  const [result, setResult] = useState([]);
  const [error, setError] = useState();
  const [mark, setMark] = useState(0);

  const [isFinished, setIsFinished] = useState(true);


  const URL = "";
  const URL_Import = "";

  let history = useHistory();

  const Bucket = "https://p450-result-prod.s3.amazonaws.com/";

  useEffect(() => {
    if (isFinished === false) {
      const timer = setInterval(() => {
        history.go(0);
      }, 30000);
      return () => clearInterval(timer);
    }
  }, [isFinished]);

  useEffect(() => {
    let current = getAllIDs();
    // console.log(current);
    if (current.length !== 0) {
      setParams(current);
      setIsLoaded1(true);
    } else {
      setParams([]);
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isLoaded1 === true) {
      getItems();
    }
  }, [isLoaded1])

  async function getItems() {
    // Amplify.Logger.LOG_LEVEL = "DEBUG";
    // const current = props;
    // console.log("file name:",current);
    console.log(params);
    const session = await Auth.currentCredentials();
    // console.log(session)
    const apiRequest = {
      body: {
        "ids": params,

      },
      headers: {
        "Content-Type": "application/json",
        // "Authorization":  session.getIdToken().getJwtToken()
      },
    };

    return await API
      .post("P450", "/alresult", apiRequest)
      .then(
        (data) => {
          if (data.statusCode === 200) {
            setItems(data.Items);
            setIsLoaded(true);
            let currentIsFinished = getStatus(data.Items);
            setIsFinished(currentIsFinished);
            console.log(data);
          } else {
            setIsLoaded(true);
            console.log(data);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  function getAllIDs() {
    var valueArr = [];
    var storage = window.localStorage
    // console.log("localStorage", storage);
    for (var i = 0; i < storage.length; i++) {
      var key = storage.key(i);
      // console.log("key",key);
      if (key.startsWith("xi-Boltz-P450-")) {
        let current = store.get(key.replaceAll("xi-", ""));
        // console.log("current",current);
        if (current.status === 0) {
          let currentItem = current.value;
          valueArr.push(currentItem);
        }
      }

    }
    // console.log("valueArr",valueArr);
    return valueArr;
  }

  //=====================================================

  function handleDelete(e) {
    let current = e.target.value;
    // alert(current);
    localStorage.removeItem("xi-" + current);

    window.location.href = "./results";

  }

  function getStatus(array) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].Status === "Queued") {
        return false;
      }
    }

    return true;
  }

  const [clicked, setClicked] = useState(false);

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  useEffect(() => {
    if (clicked) {
      simulateNetworkRequest().then(() => {
        setClicked(false);
      });
    }
  }, [clicked]);


  function handleRefresh() {
    window.location = "/results";

  }

  function handleJump(e) {
    let current = e.target.value;
    // console.log(current);
    history.push({ pathname: '/detail', state: { id: current } });
  }

  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = useState(config);

    const sortedItems = useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = key => {
      let direction = "descending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "descending"
      ) {
        direction = "ascending";
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };

  function ProjectTable(props) {
    const { items, requestSort, sortConfig } = useSortableData(props.projects);

    setMark(1);
    useEffect(() => {
      requestSort("Timestamp");
    }, [mark]);
    const getClassNamesFor = name => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                onClick={() => requestSort("ID")}
                className={getClassNamesFor("ID")}
                align="center"
              >Job ID</TableCell>
              <TableCell
                onClick={() => requestSort("Name")}
                className={getClassNamesFor("Name")}
                align="center"
              >Name</TableCell>
              <TableCell
                onClick={() => requestSort("Number")}
                className={getClassNamesFor("Number")}
                align="center"
              >Number</TableCell>
              <TableCell
                onClick={() => requestSort("Hem")}
                className={getClassNamesFor("Hem")}
                align="center"
              >Hem</TableCell>
              <TableCell
                onClick={() => requestSort("Timestamp")}
                className={getClassNamesFor("Timestamp")}
                align="center"
              >Created</TableCell>
              <TableCell
                onClick={() => requestSort("Status")}
                className={getClassNamesFor("Status")}
                align="center"
              >Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              let current_disable = row.Status !== "Finished" ? true : false;
              // console.log(row.ID,current_disable);
              return (
                <TableRow key={row.ID}>
                  {/* <TableCell align="center"><Button variant="link" disabled={current_disable} value={row.Result} onClick={handleJump}>{row.ID}</Button></TableCell> */}
                  <TableCell align="center">{row.ID}</TableCell>
                  <TableCell align="center">{row.Name}</TableCell>
                  <TableCell align="center">{row.Number}</TableCell>
                  <TableCell align="center">{row.Hem}</TableCell>
                  <TableCell align="center">{new Date(Number(row.Timestamp)).toLocaleString()}</TableCell>
                  <TableCell align="center">{row.Status}</TableCell>

                  <TableCell align="center"><ButtonGroup><Button value={row.Result} variant="outline-success" onClick={handleDownload} disabled={current_disable}>Download</Button><Button value={row.ID} variant="outline-danger" onClick={handleDelete}>Delete</Button></ButtonGroup></TableCell>
                </TableRow>

              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }


  function handleDownload(e) {
    let current = e.target.value;
    window.open(Bucket + current);
  }

  return (
    <div style={{
      background: "#FFFFFF"

    }}>

      <Row>
        <Col >
        </Col>
        <Col md={10}>

          <div style={{

            height: "50px"
          }}>
          </div>
          <div>
            {/* <Accordion>
					  <Card>
					    <Card.Header>
					      <Accordion.Toggle as={Header} eventKey="0" textAlign='center'>
					        <span style={{ color:"#6495ED"}} >User Guide</span>
					      </Accordion.Toggle>
					    </Card.Header>
					    <Accordion.Collapse eventKey="0">
					      <Card.Body>
							
							<p>PCPCM is used to predict the structure of plant P450s. PCPLD is used to dock the ligand with plant P450s. Usage as below:</p>
							<p>Step 1: Please input your own name and email.</p>
							<p>Step 2: Please choose a tool, PCPCM or PCPLD.</p>
							<p>Step 3: Please upload the file in the following format:</p>
							<p><small>To use PCPCM, you need to upload a P450 protein sequence file in FASTA format.</small></p>
							<p><small>To use PCPLD, you need to upload a P450 protein sequence file in FASTA format (or a plant P450 protein structure file in PDB format) and a ligand file in SDF format.</small></p>
							<p>Step 4: Submit.</p>
							<p>(The program will take some time to run, and we will send the results to you by email as soon as it completes.)</p>
							<div style={{height:"10px"}} />
							<p><span style={{color:"red"}}>Note:</span></p>
							<p>1. Our program has used TMHMM (Transmembrane Region Prediction Software) to automatically clip the transmembrane regions of the protein sequence uploaded.</p>
							<p>2. In the PCPLD process, the result for the screening of hypothetical substrates can only set as a reference for the prediction of true substrates.</p>
							<p>3. The related parameter files and settings of PCPCM and PCPLD are available at <a href="https://github.com/JiangLab2020/PCPD" target="_blank">https://github.com/JiangLab2020/PCPD</a>.</p>
						  </Card.Body>
					    </Accordion.Collapse>
					  </Card>
					  
					</Accordion> */}

            <Card>
              <Card.Header>
                <Header textAlign='center'>
                  <span style={{ color: "#6495ED" }} >P450 Boltz Results</span>
                </Header>
              </Card.Header>
              <Card.Body>
                <div style={{ margin: "25px 200px 25px 200px" }}>
                  <Typography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Perform structural modeling of the user-submitted sequence using Boltz.</blockquote></Typography.Paragraph>
                </div>
                <Segment basic >
                  {
                    isLoaded
                      ?
                      <ProjectTable projects={items} />
                      :
                      <Segment>
                        <Dimmer active inverted>
                          <Loader size='medium'>Loading</Loader>
                        </Dimmer>

                        <Image src='../paragraph.png' />
                      </Segment>
                  }

                  <Row>
                    <Col md={6}>
                      <ButtonGroup aria-label="Basic example">
                        <Button
                          variant="outline-secondary"
                          disabled={clicked}
                          onClick={!clicked ? handleRefresh : null}
                        >
                          {
                            clicked
                              ?
                              <Icon loading name='redo' />
                              :
                              <Icon name='redo' />
                          }

                        </Button>
                        <Button variant="outline-secondary" href="/af_submit">Back</Button>
                      </ButtonGroup>

                    </Col>
                    <Col md={6}>
                      <TablePagination
                        component="div"
                        count={count}
                        page={page}
                        onChangePage={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </Col>
                  </Row>
                </Segment>


              </Card.Body>
            </Card>


          </div>


          <div>


            <div>

            </div>



          </div>
          <div style={{

            height: "50px"
          }}>
          </div>
        </Col>
        <Col >
        </Col>
      </Row>
    </div>

  );
}